export const SET_CHECKOUT = "SET_CHECKOUT";
export const SET_CHECKOUT_RESPONSE = "SET_CHECKOUT_RESPONSE";
